import Accepted from './Accepted'
import GreaterThan from './Comparison/GreaterThan'
import GreaterThanOrEqual from './Comparison/GreaterThanOrEqual'
import LessThan from './Comparison/LessThan'
import LessThanOrEqual from './Comparison/LessThanOrEqual'
import Size from './Comparison/Size'
import Adult from './Dates/Adult'
import After from './Dates/After'
import AfterOrEqual from './Dates/AfterOrEqual'
import Before from './Dates/Before'
import BeforeOrEqual from './Dates/BeforeOrEqual'
import DateEquals from './Dates/DateEquals'
import Iban from './Iban'
import Imei from './Imei'
import Obj from './Object'
import Alpha from './Regex/AlphaNum/Alpha'
import AlphaDash from './Regex/AlphaNum/AlphaDash'
import AlphaLower from './Regex/AlphaNum/AlphaLower'
import AlphaNumeric from './Regex/AlphaNum/AlphaNumeric'
import AlphaSpace from './Regex/AlphaNum/AlphaSpace'
import AlphaUpper from './Regex/AlphaNum/AlphaUpper'
import AlphaUpperNum from './Regex/AlphaNum/AlphaUpperNum'
import Decimal from './Regex/AlphaNum/Decimal'
import Numeric from './Regex/AlphaNum/Numeric'
import Email from './Regex/Email'
import MobilePhoneNumber from './Regex/MobilePhoneNumber'
import PhoneNumber from './Regex/PhoneNumber'
import PhoneNumberInternational from './Regex/PhoneNumberInternational'
import Regex from './Regex/Regex'
import Url from './Regex/Url'
import Required from './Required/Required'
import RequiredUnless from './Required/RequiredUnless'
import RequiredWith from './Required/RequiredWith'
import Same from './Required/Same'
import Siren from './Siren'
import Str from './Str'

export default {
  accepted: Accepted,
  greaterThan: GreaterThan,
  gt: GreaterThan,
  greaterThanOrEqual: GreaterThanOrEqual,
  gte: GreaterThanOrEqual,
  min: GreaterThanOrEqual,
  lessThan: LessThan,
  lt: LessThan,
  lessThanOrEqual: LessThanOrEqual,
  lte: LessThanOrEqual,
  max: LessThanOrEqual,
  size: Size,
  alpha: Alpha,
  alphaDash: AlphaDash,
  alphaLower: AlphaLower,
  alphaNum: AlphaNumeric,
  alphaSpace: AlphaSpace,
  alphaUpper: AlphaUpper,
  alphaUpperNum: AlphaUpperNum,
  numeric: Numeric,
  adult: Adult,
  after: After,
  afterOrEqual: AfterOrEqual,
  before: Before,
  beforeOrEqual: BeforeOrEqual,
  dateEquals: DateEquals,
  email: Email,
  iban: Iban,
  imei: Imei,
  object: Obj,
  phoneNumber: PhoneNumber,
  phoneNumberInternational: PhoneNumberInternational,
  mobilePhoneNumber: MobilePhoneNumber,
  regex: Regex,
  url: Url,
  required: Required,
  requiredUnless: RequiredUnless,
  requiredWith: RequiredWith,
  same: Same,
  siren: Siren,
  string: Str,
  decimal: Decimal
}
